import { Pipe, PipeTransform } from '@angular/core';
export class StringFormatter {
    static format(value: string, ...params: string[]) {
        let i = 0;
        params.forEach(element => {
            value = value.replace('{' + i + '}', element);
            i++;
        });
        return value;
    }
}


@Pipe({
    name: 'sformatter'
})
export class StringFormatterPipe implements PipeTransform {

    transform(value: string, ...params: string[]) {
        return StringFormatter.format(value, ...params);
    }
}
